import PublisherInfoCom from './publisher-info/publisher-info.vue';
import PurchaseFormCom from './purchase-form/purchase-form.vue';
import EligibilityFormCom from './eligibility-form/eligibility-form.vue';
import AttachmentFormCom from './attachment-form/attachment-form.vue';
import CommitmentFormCom from './commitment-form/commitment-form.vue';
import SuccessCom from './success/success.vue';
import EditPurchaseFile from './edit-purchase-file/edit-purchase-file.vue';

export default [
  {
    path: 'publisher-info',
    name: 'publishPurchasePublisherInfo',
    component: PublisherInfoCom
  },
  { // 第二步：编辑项目信息
    path: 'purchase-form',
    name: 'purchaseForm',
    component: PurchaseFormCom
  },
  {
    path: 'eligibility-form',
    name: 'eligibilityForm',
    component: EligibilityFormCom
  },
  {
    path: 'attachment-form',
    name: 'attachmentForm',
    component: AttachmentFormCom
  },
  {
    path: 'commitment-form',
    name: 'commitmentForm',
    component: CommitmentFormCom
  },
  {
    path: 'success',
    name: 'publishPurchaseSuccess',
    component: SuccessCom
  },
  {
    path: 'editPurchase-file',
    name: 'editPurchaseFile',
    component: EditPurchaseFile
  }
];
